<template>
  <div>
    <!-- Dynamically render the form component based on the note type -->
    <component v-if="userFetched && formComponent" :is="formComponent" :noteDetails="noteDetails"
     :username="username" :user_id="user_id"></component>
  </div>
</template>

<style>
.custom-loader {
  position: fixed;
  margin-left: 25vw;
  width: 50vw;
  height: 5vh;
  border-radius: 20px;
  color: #F4BF00;
  border: 2px solid;
}
.custom-loader::before {
  content: "";
  position: absolute;
  margin: 2px;
  inset: 0 100% 0 0;
  border-radius: inherit;
  background: #F4BF00;
  animation: p6 2s infinite;
}
.text-loading-edit-note{
  margin-top: 40vh;
  font-size: 2em;
}

@keyframes p6 {
  100% {
    inset: 0
  }
}
</style>

<script>
import axios from 'axios';
import EditAssistanceNoteScheduled from './EditAssistanceNoteScheduled.vue'; // Example of a form component for a specific type
import EditAuxiliarNoteScheduled from './EditAuxiliarNoteScheduled.vue';
import EditForkliftNoteScheduled from './EditForkliftNoteScheduled.vue';
import EditIndustrialNoteScheduled from './EditIndustrialNoteScheduled.vue';
import EditLotNoteScheduled from './EditLotNoteScheduled.vue';
// Import other form components

export default {
  components: {
    EditAssistanceNoteScheduled,
    EditAuxiliarNoteScheduled,
    EditForkliftNoteScheduled,
    EditIndustrialNoteScheduled,
    EditLotNoteScheduled,
    // Register other form components here
  },
  data() {
    return {
      noteDetails: null, // Will hold the fetched note details
      noteType: '', // To dynamically determine which form to use
      recommendations: {},
      username : '',
      user_id : null,
      userFetched: false // Indicates if the current user has been fetched
    };
  },
  computed: {
    formComponent() {
      // Determine which component to render based on the note type
      console.log(this.noteType)
      switch (this.noteType) {
        case 1:
          return 'EditAuxiliarNoteScheduled';
        case 2:
          return 'EditAssistanceNoteScheduled';
        case 3:
          return 'EditForkliftNoteScheduled';
        case 5:
          return 'EditIndustrialNoteScheduled';
        case 4:
          return 'EditLotNoteScheduled';
        // case for other types...
        default:
          return null; // or a default form component if you have one
      }
    },
  },
  async mounted() {
    await this.fetchNoteDetails();
    await this.fetchCurrentUser();
  },
  methods: {
    async fetchNoteDetails() {
      const scheduledID = this.$route.params.scheduledID; // Get scheduledID from route params
      console.log(scheduledID,'this is the note id i got and will determine the endpoint i call')
      // Determine which endpoint to call based on the route params
      if (scheduledID.includes("FAIL")){
        try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/forklift-notes/` + scheduledID + "/");
        this.noteDetails = response.data;
        this.noteType = 3; // Assuming the response includes a type field
      } catch (error) {
        console.error("Failed to fetch note details:", error);
      }
      }
      else{
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/scheduled/` + scheduledID + "/");
        this.noteDetails = response.data;
        this.noteType = response.data.type; // Assuming the response includes a type field
      } catch (error) {
        console.error("Failed to fetch note details:", error);
        // Handle error (e.g., show user feedback)
      }
    }
    },
    fetchCurrentUser() {
      /** Fetches the current user data, used to fill in who is making an assignation */
      const apiDirectory = process.env.API_DIRECTORY;
      axios.get(`${apiDirectory}/current-user/`, {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('authToken')
        }
      })
        .then(response => {
          //this.username = response.data.username;
          //this.firstName = response.data.first_name;
          //this.lastName = response.data.last_name;
          //this.groups = response.data.groups;
          this.user_id = response.data.id;
          this.userFetched = true; // Set userFetched to true once user data is fetched
        })
        .catch(error => {
          console.error('There was an error fetching the user data:', error);
        });
    }
  },

};
</script>
